var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`sub-menu-item ${_vm.isActive ? 'active' : ''}`},[_c('typo',{attrs:{"name":"menu-14-normal"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }